import React, { useState } from 'react';
import { BarChart, DollarSign, Users, TrendingUp, Filter, Calendar, ArrowUp, ArrowDown, PieChart, LineChart, Activity, Target, Clock, Globe, Smartphone, Laptop, Tablet, Layers, Droplet, Fish, Wallet, AlertCircle, Zap, Heart, Plus, Edit, Trash2, Copy, Eye, Play, Pause, ChevronDown, Search, Download, FileText, Settings, HelpCircle, BarChart2, PieChart as PieChartIcon, TrendingDown, RefreshCw, Maximize2, Sliders, Share2, Info, Bell, CheckCircle, XCircle, Archive, CornerUpRight, Brain } from 'lucide-react';
import { Chart } from './components/Chart';
export const OffersHome: React.FC = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [dateRange, setDateRange] = useState('30d');
  const [selectedCampaign, setSelectedCampaign] = useState<string | null>(null);
  const [campaignStatus, setCampaignStatus] = useState<'all' | 'active' | 'paused' | 'scheduled' | 'ended'>('all');
  const [searchQuery, setSearchQuery] = useState('');
  // Sample data for charts
  const revenueData = [{
    date: 'Jan 1',
    revenue: 1200
  }, {
    date: 'Jan 2',
    revenue: 1400
  }, {
    date: 'Jan 3',
    revenue: 1100
  }, {
    date: 'Jan 4',
    revenue: 1600
  }, {
    date: 'Jan 5',
    revenue: 1800
  }, {
    date: 'Jan 6',
    revenue: 2000
  }, {
    date: 'Jan 7',
    revenue: 1900
  }, {
    date: 'Jan 8',
    revenue: 2200
  }, {
    date: 'Jan 9',
    revenue: 2400
  }, {
    date: 'Jan 10',
    revenue: 2100
  }, {
    date: 'Jan 11',
    revenue: 2300
  }, {
    date: 'Jan 12',
    revenue: 2500
  }, {
    date: 'Jan 13',
    revenue: 2700
  }, {
    date: 'Jan 14',
    revenue: 2400
  }];
  const conversionData = [{
    date: 'Jan 1',
    conversions: 120
  }, {
    date: 'Jan 2',
    conversions: 140
  }, {
    date: 'Jan 3',
    conversions: 110
  }, {
    date: 'Jan 4',
    conversions: 160
  }, {
    date: 'Jan 5',
    conversions: 180
  }, {
    date: 'Jan 6',
    conversions: 200
  }, {
    date: 'Jan 7',
    conversions: 190
  }, {
    date: 'Jan 8',
    conversions: 220
  }, {
    date: 'Jan 9',
    conversions: 240
  }, {
    date: 'Jan 10',
    conversions: 210
  }, {
    date: 'Jan 11',
    conversions: 230
  }, {
    date: 'Jan 12',
    conversions: 250
  }, {
    date: 'Jan 13',
    conversions: 270
  }, {
    date: 'Jan 14',
    conversions: 240
  }];
  // Updated segment data to include all required segments
  const segmentData = [{
    name: 'Whales',
    value: 35,
    color: '#8b5cf6',
    icon: <DollarSign size={14} className="inline mr-1" data-id="element-12976" />
  }, {
    name: 'Dolphins',
    value: 25,
    color: '#3b82f6',
    icon: <Droplet size={14} className="inline mr-1" data-id="element-12977" />
  }, {
    name: 'Minnows',
    value: 15,
    color: '#10b981',
    icon: <Fish size={14} className="inline mr-1" data-id="element-12978" />
  }, {
    name: 'Non-spenders',
    value: 10,
    color: '#f59e0b',
    icon: <Wallet size={14} className="inline mr-1" data-id="element-12979" />
  }, {
    name: 'Churn Risks',
    value: 10,
    color: '#ef4444',
    icon: <AlertCircle size={14} className="inline mr-1" data-id="element-12980" />
  }, {
    name: 'Emotals',
    value: 5,
    color: '#ec4899',
    icon: <Heart size={14} className="inline mr-1" data-id="element-12981" />
  }];
  const geoData = [{
    name: 'United States',
    revenue: 5200,
    conversions: 420
  }, {
    name: 'United Kingdom',
    revenue: 3100,
    conversions: 240
  }, {
    name: 'Germany',
    revenue: 2400,
    conversions: 180
  }, {
    name: 'France',
    revenue: 1800,
    conversions: 150
  }, {
    name: 'Canada',
    revenue: 1600,
    conversions: 120
  }];
  const deviceData = [{
    name: 'Mobile',
    value: 60,
    color: '#3b82f6',
    icon: <Smartphone size={14} className="inline mr-1" data-id="element-12982" />
  }, {
    name: 'Desktop',
    value: 30,
    color: '#10b981',
    icon: <Laptop size={14} className="inline mr-1" data-id="element-12983" />
  }, {
    name: 'Tablet',
    value: 10,
    color: '#f59e0b',
    icon: <Tablet size={14} className="inline mr-1" data-id="element-12984" />
  }];
  // Updated campaign data
  const campaignsData = [{
    id: 'c1',
    name: 'Summer Promotion',
    status: 'active',
    conversions: 432,
    revenue: 5432,
    roi: '+24.5%',
    startDate: '2023-06-01',
    endDate: '2023-08-31',
    budget: 2000,
    spent: 1250,
    targetSegments: ['Whales', 'Dolphins']
  }, {
    id: 'c2',
    name: 'Holiday Special',
    status: 'active',
    conversions: 287,
    revenue: 3865,
    roi: '+18.2%',
    startDate: '2023-11-15',
    endDate: '2023-12-31',
    budget: 1500,
    spent: 850,
    targetSegments: ['Dolphins', 'Minnows']
  }, {
    id: 'c3',
    name: 'Flash Sale',
    status: 'scheduled',
    conversions: 0,
    revenue: 0,
    roi: '-',
    startDate: '2023-09-15',
    endDate: '2023-09-20',
    budget: 1000,
    spent: 0,
    targetSegments: ['Non-spenders', 'Churn Risks']
  }, {
    id: 'c4',
    name: 'Spring Collection',
    status: 'ended',
    conversions: 576,
    revenue: 7219,
    roi: '+32.1%',
    startDate: '2023-03-01',
    endDate: '2023-05-31',
    budget: 2500,
    spent: 2500,
    targetSegments: ['Whales', 'Dolphins', 'Emotals']
  }, {
    id: 'c5',
    name: 'Winter Bundle',
    status: 'active',
    conversions: 342,
    revenue: 4521,
    roi: '+21.7%',
    startDate: '2023-12-01',
    endDate: '2024-02-28',
    budget: 1800,
    spent: 950,
    targetSegments: ['Minnows', 'Emotals']
  }];
  // A/B Testing data
  const abTestData = [{
    id: 'test1',
    name: 'Banner Design Test',
    status: 'active',
    startDate: '2023-07-15',
    endDate: '2023-08-15',
    variants: [{
      name: 'A (Control)',
      conversions: 215,
      impressions: 5000,
      conversionRate: 4.3
    }, {
      name: 'B (Variant)',
      conversions: 254,
      impressions: 5000,
      conversionRate: 5.08
    }],
    winner: 'B',
    improvement: '+18%'
  }, {
    id: 'test2',
    name: 'CTA Text Test',
    status: 'active',
    startDate: '2023-07-20',
    endDate: '2023-08-20',
    variants: [{
      name: 'A (Control)',
      conversions: 187,
      impressions: 4000,
      conversionRate: 4.68
    }, {
      name: 'B (Variant)',
      conversions: 195,
      impressions: 4000,
      conversionRate: 4.88
    }],
    winner: null,
    improvement: '+4.3%'
  }, {
    id: 'test3',
    name: 'Pricing Display Test',
    status: 'ended',
    startDate: '2023-06-01',
    endDate: '2023-07-01',
    variants: [{
      name: 'A (Control)',
      conversions: 310,
      impressions: 6000,
      conversionRate: 5.17
    }, {
      name: 'B (Variant)',
      conversions: 378,
      impressions: 6000,
      conversionRate: 6.3
    }],
    winner: 'B',
    improvement: '+21.9%'
  }];
  // Custom reports data
  const customReportsData = [{
    id: 'r1',
    name: 'Segment Performance Report',
    description: 'Detailed breakdown of performance by user segment',
    lastRun: '2023-08-10',
    schedule: 'Weekly',
    format: 'PDF'
  }, {
    id: 'r2',
    name: 'Campaign ROI Analysis',
    description: 'Comprehensive ROI analysis across all campaigns',
    lastRun: '2023-08-12',
    schedule: 'Monthly',
    format: 'Excel'
  }, {
    id: 'r3',
    name: 'Geographic Performance',
    description: 'Performance metrics broken down by geographic region',
    lastRun: '2023-08-05',
    schedule: 'Monthly',
    format: 'PDF'
  }, {
    id: 'r4',
    name: 'Conversion Funnel Analysis',
    description: 'Step-by-step analysis of the conversion funnel',
    lastRun: '2023-08-11',
    schedule: 'Bi-weekly',
    format: 'Excel'
  }];
  // Forecasting data
  const forecastingData = [{
    month: 'Sep',
    actual: null,
    forecast: 13500
  }, {
    month: 'Oct',
    actual: null,
    forecast: 14200
  }, {
    month: 'Nov',
    actual: null,
    forecast: 15800
  }, {
    month: 'Dec',
    actual: null,
    forecast: 18500
  }];
  const revenueBySegmentData = {
    total: 12426,
    segments: [{
      name: 'Whales',
      value: 35,
      color: 'bg-purple-500',
      textColor: 'text-purple-500',
      icon: <DollarSign size={14} className="inline mr-1" data-id="element-12985" />,
      revenue: 4349.1
    }, {
      name: 'Dolphins',
      value: 25,
      color: 'bg-blue-500',
      textColor: 'text-blue-500',
      icon: <Droplet size={14} className="inline mr-1" data-id="element-12986" />,
      revenue: 3106.5
    }, {
      name: 'Minnows',
      value: 15,
      color: 'bg-emerald-500',
      textColor: 'text-emerald-500',
      icon: <Fish size={14} className="inline mr-1" data-id="element-12987" />,
      revenue: 1863.9
    }, {
      name: 'Non-spenders',
      value: 10,
      color: 'bg-amber-500',
      textColor: 'text-amber-500',
      icon: <Wallet size={14} className="inline mr-1" data-id="element-12988" />,
      revenue: 1242.6
    }, {
      name: 'Churn Risks',
      value: 10,
      color: 'bg-red-500',
      textColor: 'text-red-500',
      icon: <AlertCircle size={14} className="inline mr-1" data-id="element-12989" />,
      revenue: 1242.6
    }, {
      name: 'Emotals',
      value: 5,
      color: 'bg-pink-500',
      textColor: 'text-pink-500',
      icon: <Heart size={14} className="inline mr-1" data-id="element-12990" />,
      revenue: 621.3
    }]
  };
  const renderRevenueBySegmentChart = () => {
    return <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4" data-id="element-12991">
        <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-4" data-id="element-12992">
          Revenue by Segment
        </h3>
        <div className="flex items-center" data-id="element-12993">
          <div className="relative w-24 h-24" data-id="element-12994">
            <svg className="w-full h-full" viewBox="0 0 100 100" data-id="element-12995">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#f3f4f6" strokeWidth="20" data-id="element-12996" />
              {revenueBySegmentData.segments.map((segment, index) => {
              const startAngle = index > 0 ? revenueBySegmentData.segments.slice(0, index).reduce((sum, s) => sum + s.value, 0) : 0;
              const endAngle = startAngle + segment.value;
              return <circle key={segment.name} cx="50" cy="50" r="40" fill="none" stroke={`var(--${segment.color.replace('bg-', '')})`} strokeWidth="20" strokeDasharray={`${segment.value * 2.51} 251`} strokeDashoffset={`${251 - startAngle * 2.51}`} transform="rotate(-90 50 50)" data-id="element-12997" />;
            })}
              <text x="50" y="45" textAnchor="middle" className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-12998">
                Total
              </text>
              <text x="50" y="65" textAnchor="middle" className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-12999">
                ${revenueBySegmentData.total.toLocaleString()}
              </text>
            </svg>
          </div>
          <div className="ml-8 space-y-2" data-id="element-13000">
            {revenueBySegmentData.segments.map(segment => <div key={segment.name} className="flex justify-between items-center" data-id="element-13001">
                <div className="flex items-center" data-id="element-13002">
                  <span className={`w-3 h-3 rounded-full ${segment.color} mr-2`} data-id="element-13003"></span>
                  <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-13004">
                    {segment.icon} {segment.name}
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-13005">
                  <span className={`text-sm font-medium ${segment.textColor}`} data-id="element-13006">
                    {segment.value}%
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-13007">
                    ${segment.revenue.toLocaleString()}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>;
  };
  const renderCampaignsTab = () => {
    const filteredCampaigns = campaignsData.filter(campaign => {
      // Filter by status if not "all"
      if (campaignStatus !== 'all' && campaign.status !== campaignStatus) {
        return false;
      }
      // Filter by search query
      if (searchQuery && !campaign.name.toLowerCase().includes(searchQuery.toLowerCase())) {
        return false;
      }
      return true;
    });
    return <>
        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm mb-6" data-id="element-13008">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6" data-id="element-13009">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13010">
              Campaign Management
            </h3>
            <div className="flex items-center gap-2" data-id="element-13011">
              <button className="px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium flex items-center gap-1" data-id="element-13012">
                <Plus size={16} data-id="element-13013" />
                <span data-id="element-13014">Create Campaign</span>
              </button>
              <button className="px-3 py-2 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-md text-sm font-medium flex items-center gap-1" data-id="element-13015">
                <Download size={16} data-id="element-13016" />
                <span data-id="element-13017">Export</span>
              </button>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6" data-id="element-13018">
            <div className="relative flex-1" data-id="element-13019">
              <input type="text" placeholder="Search campaigns..." className="w-full pl-9 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-13020" />
              <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-13021" />
            </div>
            <div className="flex items-center gap-2" data-id="element-13022">
              <label className="text-sm text-gray-600 dark:text-gray-400" data-id="element-13023">
                Status:
              </label>
              <select className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300" value={campaignStatus} onChange={e => setCampaignStatus(e.target.value as any)} data-id="element-13024">
                <option value="all" data-id="element-13025">All</option>
                <option value="active" data-id="element-13026">Active</option>
                <option value="paused" data-id="element-13027">Paused</option>
                <option value="scheduled" data-id="element-13028">Scheduled</option>
                <option value="ended" data-id="element-13029">Ended</option>
              </select>
              <button className="px-3 py-2 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-md text-sm flex items-center gap-1" data-id="element-13030">
                <Filter size={16} data-id="element-13031" />
                <span data-id="element-13032">More Filters</span>
              </button>
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-13033">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-13034">
              <thead data-id="element-13035">
                <tr className="bg-gray-50 dark:bg-gray-800/60" data-id="element-13036">
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13037">
                    Campaign
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13038">
                    Status
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13039">
                    Period
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13040">
                    Budget
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13041">
                    Target Segments
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13042">
                    Conversions
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13043">
                    Revenue
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13044">
                    ROI
                  </th>
                  <th scope="col" className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13045">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-13046">
                {filteredCampaigns.map(campaign => <tr key={campaign.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/30" data-id="element-13047">
                    <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-13048">
                      {campaign.name}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-13049">
                      <span className={`px-2 py-1 text-xs rounded-full ${campaign.status === 'active' ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400' : campaign.status === 'paused' ? 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-400' : campaign.status === 'scheduled' ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-400' : 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-400'}`} data-id="element-13050">
                        {campaign.status.charAt(0).toUpperCase() + campaign.status.slice(1)}
                      </span>
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300" data-id="element-13051">
                      {campaign.startDate} to {campaign.endDate}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300" data-id="element-13052">
                      ${campaign.spent.toLocaleString()} / $
                      {campaign.budget.toLocaleString()}
                      <div className="w-24 h-2 bg-gray-200 dark:bg-gray-700 rounded-full mt-1 overflow-hidden" data-id="element-13053">
                        <div className="h-full bg-blue-500 rounded-full" style={{
                      width: `${campaign.spent / campaign.budget * 100}%`
                    }} data-id="element-13054"></div>
                      </div>
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300" data-id="element-13055">
                      <div className="flex flex-wrap gap-1" data-id="element-13056">
                        {campaign.targetSegments.map(segment => <span key={segment} className="px-2 py-0.5 bg-gray-100 dark:bg-gray-700 rounded text-xs" data-id="element-13057">
                            {segment}
                          </span>)}
                      </div>
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300" data-id="element-13058">
                      {campaign.conversions.toLocaleString()}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-13059">
                      ${campaign.revenue.toLocaleString()}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-green-600 dark:text-green-400" data-id="element-13060">
                      {campaign.roi}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-right text-sm" data-id="element-13061">
                      <div className="flex items-center justify-end gap-2" data-id="element-13062">
                        <button className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-13063">
                          <Edit size={16} data-id="element-13064" />
                        </button>
                        {campaign.status === 'active' ? <button className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-13065">
                            <Pause size={16} data-id="element-13066" />
                          </button> : campaign.status === 'paused' || campaign.status === 'scheduled' ? <button className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-13067">
                            <Play size={16} data-id="element-13068" />
                          </button> : null}
                        <button className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-13069">
                          <Copy size={16} data-id="element-13070" />
                        </button>
                        <button className="p-1 text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300" data-id="element-13071">
                          <Trash2 size={16} data-id="element-13072" />
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          {filteredCampaigns.length === 0 && <div className="py-8 text-center text-gray-500 dark:text-gray-400" data-id="element-13073">
              No campaigns found. Try adjusting your filters.
            </div>}
          <div className="flex items-center justify-between mt-4" data-id="element-13074">
            <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-13075">
              Showing {filteredCampaigns.length} of {campaignsData.length}{' '}
              campaigns
            </div>
            <div className="flex items-center gap-2" data-id="element-13076">
              <button className="px-3 py-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded text-gray-500 dark:text-gray-400 text-sm" data-id="element-13077">
                Previous
              </button>
              <button className="px-3 py-1 bg-blue-600 text-white rounded text-sm" data-id="element-13078">
                1
              </button>
              <button className="px-3 py-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded text-gray-500 dark:text-gray-400 text-sm" data-id="element-13079">
                2
              </button>
              <button className="px-3 py-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded text-gray-500 dark:text-gray-400 text-sm" data-id="element-13080">
                Next
              </button>
            </div>
          </div>
        </div>
        {selectedCampaign && <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13081">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4" data-id="element-13082">
              Campaign Details
            </h3>
            {/* Campaign details would go here */}
          </div>}
      </>;
  };
  const renderPerformanceTab = () => {
    return <>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-13083">
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13084">
            <div className="flex items-center justify-between mb-2" data-id="element-13085">
              <h3 className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-13086">
                Conversion Rate
              </h3>
              <div className="w-8 h-8 rounded-full bg-indigo-100 dark:bg-indigo-900 flex items-center justify-center" data-id="element-13087">
                <Target size={16} className="text-indigo-600 dark:text-indigo-400" data-id="element-13088" />
              </div>
            </div>
            <h4 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-13089">
              5.64%
            </h4>
            <div className="flex items-center mt-2" data-id="element-13090">
              <span className="text-xs px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-full flex items-center" data-id="element-13091">
                <ArrowUp size={10} className="mr-1" data-id="element-13092" />
                0.8%
              </span>
              <span className="ml-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-13093">
                vs last period
              </span>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13094">
            <div className="flex items-center justify-between mb-2" data-id="element-13095">
              <h3 className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-13096">
                Click-Through Rate
              </h3>
              <div className="w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center" data-id="element-13097">
                <CornerUpRight size={16} className="text-blue-600 dark:text-blue-400" data-id="element-13098" />
              </div>
            </div>
            <h4 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-13099">
              3.27%
            </h4>
            <div className="flex items-center mt-2" data-id="element-13100">
              <span className="text-xs px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400 rounded-full flex items-center" data-id="element-13101">
                <ArrowDown size={10} className="mr-1" data-id="element-13102" />
                0.3%
              </span>
              <span className="ml-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-13103">
                vs last period
              </span>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13104">
            <div className="flex items-center justify-between mb-2" data-id="element-13105">
              <h3 className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-13106">
                Cost Per Acquisition
              </h3>
              <div className="w-8 h-8 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center" data-id="element-13107">
                <DollarSign size={16} className="text-green-600 dark:text-green-400" data-id="element-13108" />
              </div>
            </div>
            <h4 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-13109">
              $4.82
            </h4>
            <div className="flex items-center mt-2" data-id="element-13110">
              <span className="text-xs px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-full flex items-center" data-id="element-13111">
                <ArrowDown size={10} className="mr-1" data-id="element-13112" />
                $0.31
              </span>
              <span className="ml-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-13113">
                vs last period
              </span>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-13114">
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13115">
            <div className="flex items-center justify-between mb-4" data-id="element-13116">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13117">
                Segment Performance
              </h3>
              <button className="text-sm text-blue-600 dark:text-blue-400 hover:underline flex items-center" data-id="element-13118">
                <Download size={14} className="mr-1" data-id="element-13119" />
                Export Data
              </button>
            </div>
            <div className="space-y-4" data-id="element-13120">
              {revenueBySegmentData.segments.map(segment => <div key={segment.name} className="bg-gray-50 dark:bg-gray-700/30 p-3 rounded-lg" data-id="element-13121">
                  <div className="flex items-center justify-between mb-2" data-id="element-13122">
                    <div className="flex items-center" data-id="element-13123">
                      <span className={`w-3 h-3 rounded-full ${segment.color} mr-2`} data-id="element-13124"></span>
                      <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-13125">
                        {segment.icon} {segment.name}
                      </span>
                    </div>
                    <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-13126">
                      ${segment.revenue.toLocaleString()}
                    </span>
                  </div>
                  <div className="grid grid-cols-3 gap-4 text-xs" data-id="element-13127">
                    <div data-id="element-13128">
                      <p className="text-gray-500 dark:text-gray-400" data-id="element-13129">
                        Conversion Rate
                      </p>
                      <p className="font-medium text-gray-900 dark:text-white mt-1" data-id="element-13130">
                        {(5.64 * (segment.value / 20)).toFixed(2)}%
                      </p>
                    </div>
                    <div data-id="element-13131">
                      <p className="text-gray-500 dark:text-gray-400" data-id="element-13132">
                        Avg. Order Value
                      </p>
                      <p className="font-medium text-gray-900 dark:text-white mt-1" data-id="element-13133">
                        ${(38 + segment.value).toFixed(2)}
                      </p>
                    </div>
                    <div data-id="element-13134">
                      <p className="text-gray-500 dark:text-gray-400" data-id="element-13135">
                        Retention Rate
                      </p>
                      <p className="font-medium text-gray-900 dark:text-white mt-1" data-id="element-13136">
                        {(42 + segment.value / 2).toFixed(1)}%
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13137">
            <div className="flex items-center justify-between mb-4" data-id="element-13138">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13139">
                A/B Testing Results
              </h3>
              <button className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm flex items-center" data-id="element-13140">
                <Plus size={14} className="mr-1" data-id="element-13141" />
                New Test
              </button>
            </div>
            <div className="space-y-4" data-id="element-13142">
              {abTestData.map(test => <div key={test.id} className="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden" data-id="element-13143">
                  <div className="bg-gray-50 dark:bg-gray-700/30 px-4 py-3 flex items-center justify-between" data-id="element-13144">
                    <div data-id="element-13145">
                      <h4 className="font-medium text-gray-900 dark:text-white" data-id="element-13146">
                        {test.name}
                      </h4>
                      <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-13147">
                        {test.startDate} to {test.endDate}
                      </p>
                    </div>
                    <span className={`px-2 py-1 text-xs rounded-full ${test.status === 'active' ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400' : 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-400'}`} data-id="element-13148">
                      {test.status.charAt(0).toUpperCase() + test.status.slice(1)}
                    </span>
                  </div>
                  <div className="p-4" data-id="element-13149">
                    <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-13150">
                      {test.variants.map((variant, index) => <div key={variant.name} className={`p-3 rounded-lg ${test.winner === (index === 0 ? 'A' : 'B') ? 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800' : 'bg-gray-50 dark:bg-gray-700/30'}`} data-id="element-13151">
                          <div className="flex items-center justify-between mb-2" data-id="element-13152">
                            <span className="font-medium text-gray-900 dark:text-white" data-id="element-13153">
                              {variant.name}
                            </span>
                            {test.winner === (index === 0 ? 'A' : 'B') && <span className="flex items-center text-xs text-green-600 dark:text-green-400" data-id="element-13154">
                                <CheckCircle size={12} className="mr-1" data-id="element-13155" />
                                Winner
                              </span>}
                          </div>
                          <div className="grid grid-cols-2 gap-2 text-xs" data-id="element-13156">
                            <div data-id="element-13157">
                              <p className="text-gray-500 dark:text-gray-400" data-id="element-13158">
                                Conversions
                              </p>
                              <p className="font-medium text-gray-900 dark:text-white" data-id="element-13159">
                                {variant.conversions}
                              </p>
                            </div>
                            <div data-id="element-13160">
                              <p className="text-gray-500 dark:text-gray-400" data-id="element-13161">
                                Conv. Rate
                              </p>
                              <p className="font-medium text-gray-900 dark:text-white" data-id="element-13162">
                                {variant.conversionRate}%
                              </p>
                            </div>
                          </div>
                        </div>)}
                    </div>
                    <div className="flex items-center justify-between text-sm" data-id="element-13163">
                      <div className="flex items-center" data-id="element-13164">
                        <Info size={14} className="text-gray-400 mr-1" data-id="element-13165" />
                        <span className="text-gray-500 dark:text-gray-400" data-id="element-13166">
                          {test.winner ? 'Test complete with' : 'Current improvement:'}
                          <span className="text-green-600 dark:text-green-400 font-medium ml-1" data-id="element-13167">
                            {test.improvement}
                          </span>
                        </span>
                      </div>
                      <button className="text-blue-600 dark:text-blue-400 hover:underline" data-id="element-13168">
                        View Details
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm mb-6" data-id="element-13169">
          <div className="flex items-center justify-between mb-4" data-id="element-13170">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13171">
              Optimization Recommendations
            </h3>
            <div className="flex items-center" data-id="element-13172">
              <span className="text-xs text-gray-500 dark:text-gray-400 mr-2" data-id="element-13173">
                Last updated: Today, 2:30 PM
              </span>
              <button className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-13174">
                <RefreshCw size={16} data-id="element-13175" />
              </button>
            </div>
          </div>
          <div className="space-y-4" data-id="element-13176">
            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4" data-id="element-13177">
              <div className="flex items-start" data-id="element-13178">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-800 flex items-center justify-center mr-3" data-id="element-13179">
                  <Target size={16} className="text-blue-600 dark:text-blue-400" data-id="element-13180" />
                </div>
                <div data-id="element-13181">
                  <h4 className="font-medium text-gray-900 dark:text-white mb-1" data-id="element-13182">
                    Increase budget for "Summer Promotion" campaign
                  </h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-13183">
                    This campaign is performing 24.5% above average. Increasing
                    budget by 20% could yield an additional $1,200 in revenue.
                  </p>
                  <div className="flex items-center gap-2" data-id="element-13184">
                    <button className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm" data-id="element-13185">
                      Apply Recommendation
                    </button>
                    <button className="px-3 py-1.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded text-sm" data-id="element-13186">
                      Dismiss
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4" data-id="element-13187">
              <div className="flex items-start" data-id="element-13188">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-amber-100 dark:bg-amber-800 flex items-center justify-center mr-3" data-id="element-13189">
                  <BarChart size={16} className="text-amber-600 dark:text-amber-400" data-id="element-13190" />
                </div>
                <div data-id="element-13191">
                  <h4 className="font-medium text-gray-900 dark:text-white mb-1" data-id="element-13192">
                    Optimize targeting for "Dolphins" segment
                  </h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-13193">
                    "Dolphins" segment shows 15% higher conversion potential.
                    Adjusting targeting parameters could improve campaign
                    performance.
                  </p>
                  <div className="flex items-center gap-2" data-id="element-13194">
                    <button className="px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white rounded text-sm" data-id="element-13195">
                      Review Targeting
                    </button>
                    <button className="px-3 py-1.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded text-sm" data-id="element-13196">
                      Dismiss
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4" data-id="element-13197">
              <div className="flex items-start" data-id="element-13198">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-100 dark:bg-green-800 flex items-center justify-center mr-3" data-id="element-13199">
                  <LineChart size={16} className="text-green-600 dark:text-green-400" data-id="element-13200" />
                </div>
                <div data-id="element-13201">
                  <h4 className="font-medium text-gray-900 dark:text-white mb-1" data-id="element-13202">
                    Implement winning variant from "Banner Design Test"
                  </h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-13203">
                    Variant B shows 18% higher conversion rate. Implementing
                    this design across all campaigns could boost overall
                    performance.
                  </p>
                  <div className="flex items-center gap-2" data-id="element-13204">
                    <button className="px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white rounded text-sm" data-id="element-13205">
                      Apply to All Campaigns
                    </button>
                    <button className="px-3 py-1.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded text-sm" data-id="element-13206">
                      Review Test Results
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>;
  };
  const renderAnalyticsTab = () => {
    return <>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-13207">
          <div className="col-span-2 bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13208">
            <div className="flex items-center justify-between mb-4" data-id="element-13209">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13210">
                Revenue Forecast
              </h3>
              <div className="flex items-center gap-2" data-id="element-13211">
                <button className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-xs rounded" data-id="element-13212">
                  3 Months
                </button>
                <button className="px-2 py-1 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400 text-xs rounded" data-id="element-13213">
                  6 Months
                </button>
                <button className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-xs rounded" data-id="element-13214">
                  1 Year
                </button>
              </div>
            </div>
            <div className="h-64 mb-4" data-id="element-13215">
              <Chart title="Revenue Forecast" data={[{
              month: 'May',
              actual: 8500,
              forecast: null
            }, {
              month: 'Jun',
              actual: 9200,
              forecast: null
            }, {
              month: 'Jul',
              actual: 10800,
              forecast: null
            }, {
              month: 'Aug',
              actual: 12426,
              forecast: null
            }, ...forecastingData]} type="line" height={250} yAxisLabel="Revenue ($)" xAxisDataKey="month" colors={['#10b981', '#3b82f6']} dataKeys={['actual', 'forecast']} data-id="element-13216" />
            </div>
            <div className="flex items-center justify-between" data-id="element-13217">
              <div className="flex items-center gap-4" data-id="element-13218">
                <div className="flex items-center" data-id="element-13219">
                  <span className="w-3 h-3 rounded-full bg-emerald-500 mr-2" data-id="element-13220"></span>
                  <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-13221">
                    Actual Revenue
                  </span>
                </div>
                <div className="flex items-center" data-id="element-13222">
                  <span className="w-3 h-3 rounded-full bg-blue-500 mr-2" data-id="element-13223"></span>
                  <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-13224">
                    Forecasted Revenue
                  </span>
                </div>
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-13225">
                Forecast Confidence:{' '}
                <span className="font-medium text-gray-900 dark:text-white" data-id="element-13226">
                  87%
                </span>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13227">
            <div className="flex items-center justify-between mb-4" data-id="element-13228">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13229">
                Cohort Analysis
              </h3>
              <button className="text-sm text-blue-600 dark:text-blue-400 hover:underline flex items-center" data-id="element-13230">
                <Maximize2 size={14} className="mr-1" data-id="element-13231" />
                Full Report
              </button>
            </div>
            <div className="space-y-4" data-id="element-13232">
              <div data-id="element-13233">
                <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-13234">
                  Retention by Segment
                </h4>
                <div className="overflow-x-auto" data-id="element-13235">
                  <table className="min-w-full text-xs" data-id="element-13236">
                    <thead data-id="element-13237">
                      <tr className="bg-gray-50 dark:bg-gray-700/30" data-id="element-13238">
                        <th className="px-2 py-2 text-left font-medium text-gray-500 dark:text-gray-400" data-id="element-13239">
                          Segment
                        </th>
                        <th className="px-2 py-2 text-center font-medium text-gray-500 dark:text-gray-400" data-id="element-13240">
                          Week 1
                        </th>
                        <th className="px-2 py-2 text-center font-medium text-gray-500 dark:text-gray-400" data-id="element-13241">
                          Week 2
                        </th>
                        <th className="px-2 py-2 text-center font-medium text-gray-500 dark:text-gray-400" data-id="element-13242">
                          Week 4
                        </th>
                        <th className="px-2 py-2 text-center font-medium text-gray-500 dark:text-gray-400" data-id="element-13243">
                          Week 8
                        </th>
                      </tr>
                    </thead>
                    <tbody data-id="element-13244">
                      {revenueBySegmentData.segments.map(segment => <tr key={segment.name} className="border-b border-gray-200 dark:border-gray-700" data-id="element-13245">
                          <td className="px-2 py-2 whitespace-nowrap font-medium text-gray-700 dark:text-gray-300" data-id="element-13246">
                            <div className="flex items-center" data-id="element-13247">
                              <span className={`w-2 h-2 rounded-full ${segment.color} mr-1`} data-id="element-13248"></span>
                              {segment.name}
                            </div>
                          </td>
                          <td className="px-2 py-2 text-center text-gray-700 dark:text-gray-300" data-id="element-13249">
                            100%
                          </td>
                          <td className="px-2 py-2 text-center text-gray-700 dark:text-gray-300" data-id="element-13250">
                            {(85 + segment.value / 2).toFixed(1)}%
                          </td>
                          <td className="px-2 py-2 text-center text-gray-700 dark:text-gray-300" data-id="element-13251">
                            {(70 + segment.value / 2).toFixed(1)}%
                          </td>
                          <td className="px-2 py-2 text-center text-gray-700 dark:text-gray-300" data-id="element-13252">
                            {(55 + segment.value / 2).toFixed(1)}%
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>
              <div data-id="element-13253">
                <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-13254">
                  LTV by Segment
                </h4>
                <div className="space-y-2" data-id="element-13255">
                  {revenueBySegmentData.segments.map(segment => <div key={segment.name} className="flex items-center" data-id="element-13256">
                      <div className="w-24 flex-shrink-0" data-id="element-13257">
                        <div className="flex items-center" data-id="element-13258">
                          <span className={`w-2 h-2 rounded-full ${segment.color} mr-1`} data-id="element-13259"></span>
                          <span className="text-xs text-gray-700 dark:text-gray-300" data-id="element-13260">
                            {segment.name}
                          </span>
                        </div>
                      </div>
                      <div className="flex-1 ml-2" data-id="element-13261">
                        <div className="flex items-center" data-id="element-13262">
                          <div className="flex-1 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-13263">
                            <div className={segment.color.replace('bg-', 'bg-')} style={{
                          width: `${segment.value * 5}%`,
                          height: '100%'
                        }} data-id="element-13264"></div>
                          </div>
                          <span className="ml-2 text-xs font-medium text-gray-700 dark:text-gray-300" data-id="element-13265">
                            ${(segment.value * 5).toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-13266">
          <div className="col-span-2 bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13267">
            <div className="flex items-center justify-between mb-4" data-id="element-13268">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13269">
                Custom Reports
              </h3>
              <button className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm flex items-center" data-id="element-13270">
                <Plus size={14} className="mr-1" data-id="element-13271" />
                New Report
              </button>
            </div>
            <div className="overflow-x-auto" data-id="element-13272">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-13273">
                <thead data-id="element-13274">
                  <tr className="bg-gray-50 dark:bg-gray-700/30" data-id="element-13275">
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13276">
                      Report Name
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13277">
                      Description
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13278">
                      Last Run
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13279">
                      Schedule
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13280">
                      Format
                    </th>
                    <th scope="col" className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13281">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 dark:divide-gray-700" data-id="element-13282">
                  {customReportsData.map(report => <tr key={report.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/30" data-id="element-13283">
                      <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-13284">
                        {report.name}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-700 dark:text-gray-300" data-id="element-13285">
                        {report.description}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300" data-id="element-13286">
                        {report.lastRun}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300" data-id="element-13287">
                        {report.schedule}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300" data-id="element-13288">
                        <span className={`px-2 py-1 text-xs rounded ${report.format === 'PDF' ? 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400' : 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400'}`} data-id="element-13289">
                          {report.format}
                        </span>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-right text-sm" data-id="element-13290">
                        <div className="flex items-center justify-end gap-2" data-id="element-13291">
                          <button className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-13292">
                            <Play size={16} data-id="element-13293" />
                          </button>
                          <button className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-13294">
                            <Edit size={16} data-id="element-13295" />
                          </button>
                          <button className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-13296">
                            <Download size={16} data-id="element-13297" />
                          </button>
                          <button className="p-1 text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300" data-id="element-13298">
                            <Trash2 size={16} data-id="element-13299" />
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13300">
            <div className="flex items-center justify-between mb-4" data-id="element-13301">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13302">
                Data Export
              </h3>
              <button className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" data-id="element-13303">
                <HelpCircle size={16} data-id="element-13304" />
              </button>
            </div>
            <div className="space-y-4" data-id="element-13305">
              <div className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/30 cursor-pointer" data-id="element-13306">
                <div className="flex items-center mb-2" data-id="element-13307">
                  <FileText size={16} className="text-blue-600 dark:text-blue-400 mr-2" data-id="element-13308" />
                  <h4 className="font-medium text-gray-900 dark:text-white" data-id="element-13309">
                    Complete Dataset
                  </h4>
                </div>
                <p className="text-xs text-gray-600 dark:text-gray-400 mb-2" data-id="element-13310">
                  Export all data for the selected date range in CSV format
                </p>
                <button className="w-full px-3 py-1.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded text-sm flex items-center justify-center" data-id="element-13311">
                  <Download size={14} className="mr-1" data-id="element-13312" />
                  Export CSV
                </button>
              </div>
              <div className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/30 cursor-pointer" data-id="element-13313">
                <div className="flex items-center mb-2" data-id="element-13314">
                  <BarChart2 size={16} className="text-green-600 dark:text-green-400 mr-2" data-id="element-13315" />
                  <h4 className="font-medium text-gray-900 dark:text-white" data-id="element-13316">
                    Segment Analysis
                  </h4>
                </div>
                <p className="text-xs text-gray-600 dark:text-gray-400 mb-2" data-id="element-13317">
                  Detailed performance metrics for each user segment
                </p>
                <button className="w-full px-3 py-1.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded text-sm flex items-center justify-center" data-id="element-13318">
                  <Download size={14} className="mr-1" data-id="element-13319" />
                  Export Excel
                </button>
              </div>
              <div className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/30 cursor-pointer" data-id="element-13320">
                <div className="flex items-center mb-2" data-id="element-13321">
                  <PieChartIcon size={16} className="text-purple-600 dark:text-purple-400 mr-2" data-id="element-13322" />
                  <h4 className="font-medium text-gray-900 dark:text-white" data-id="element-13323">
                    Campaign Performance
                  </h4>
                </div>
                <p className="text-xs text-gray-600 dark:text-gray-400 mb-2" data-id="element-13324">
                  Performance data for all active and completed campaigns
                </p>
                <button className="w-full px-3 py-1.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded text-sm flex items-center justify-center" data-id="element-13325">
                  <Download size={14} className="mr-1" data-id="element-13326" />
                  Export PDF
                </button>
              </div>
              <div className="mt-4" data-id="element-13327">
                <button className="w-full px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium flex items-center justify-center" data-id="element-13328">
                  <Settings size={14} className="mr-1" data-id="element-13329" />
                  Configure Data Exports
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm mb-6" data-id="element-13330">
          <div className="flex items-center justify-between mb-4" data-id="element-13331">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13332">
              Advanced Analytics Settings
            </h3>
            <button className="px-3 py-1.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded text-sm flex items-center" data-id="element-13333">
              <Sliders size={14} className="mr-1" data-id="element-13334" />
              Configure
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-13335">
            <div className="bg-gray-50 dark:bg-gray-700/30 p-3 rounded-lg" data-id="element-13336">
              <h4 className="font-medium text-gray-900 dark:text-white mb-2 flex items-center" data-id="element-13337">
                <Bell size={16} className="text-blue-600 dark:text-blue-400 mr-2" data-id="element-13338" />
                Anomaly Detection
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400 mb-3" data-id="element-13339">
                Automatically detect unusual patterns in your data
              </p>
              <div className="flex items-center justify-between" data-id="element-13340">
                <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-13341">
                  Status:
                </span>
                <span className="text-xs font-medium text-green-600 dark:text-green-400 flex items-center" data-id="element-13342">
                  <CheckCircle size={12} className="mr-1" data-id="element-13343" />
                  Active
                </span>
              </div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-700/30 p-3 rounded-lg" data-id="element-13344">
              <h4 className="font-medium text-gray-900 dark:text-white mb-2 flex items-center" data-id="element-13345">
                <Share2 size={16} className="text-purple-600 dark:text-purple-400 mr-2" data-id="element-13346" />
                Data Sharing
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400 mb-3" data-id="element-13347">
                Share reports with team members and stakeholders
              </p>
              <div className="flex items-center justify-between" data-id="element-13348">
                <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-13349">
                  Status:
                </span>
                <span className="text-xs font-medium text-green-600 dark:text-green-400 flex items-center" data-id="element-13350">
                  <CheckCircle size={12} className="mr-1" data-id="element-13351" />
                  Active
                </span>
              </div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-700/30 p-3 rounded-lg" data-id="element-13352">
              <h4 className="font-medium text-gray-900 dark:text-white mb-2 flex items-center" data-id="element-13353">
                <Brain size={16} className="text-amber-600 dark:text-amber-400 mr-2" data-id="element-13354" />
                AI Predictions
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400 mb-3" data-id="element-13355">
                Use machine learning to predict future performance
              </p>
              <div className="flex items-center justify-between" data-id="element-13356">
                <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-13357">
                  Status:
                </span>
                <span className="text-xs font-medium text-red-600 dark:text-red-400 flex items-center" data-id="element-13358">
                  <XCircle size={12} className="mr-1" data-id="element-13359" />
                  Inactive
                </span>
              </div>
            </div>
          </div>
        </div>
      </>;
  };
  return <div className="w-full bg-white dark:bg-gray-900 p-6 rounded-lg shadow-sm" data-id="element-13360">
      <div className="flex items-center justify-between mb-6" data-id="element-13361">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-13362">
          Offers Dashboard
        </h1>
        <div className="flex items-center gap-2" data-id="element-13363">
          <button className="px-4 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-gray-700 dark:text-gray-300 text-sm font-medium flex items-center gap-2 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" data-id="element-13364">
            <Filter size={16} data-id="element-13365" />
            <span data-id="element-13366">Filter</span>
          </button>
          <select className="px-4 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-gray-700 dark:text-gray-300 text-sm font-medium border-none outline-none" value={dateRange} onChange={e => setDateRange(e.target.value)} data-id="element-13367">
            <option value="today" data-id="element-13368">Today</option>
            <option value="yesterday" data-id="element-13369">Yesterday</option>
            <option value="7d" data-id="element-13370">Last 7 days</option>
            <option value="30d" data-id="element-13371">Last 30 days</option>
            <option value="90d" data-id="element-13372">Last 90 days</option>
            <option value="12m" data-id="element-13373">Last 12 months</option>
          </select>
          <button className="px-4 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-gray-700 dark:text-gray-300 text-sm font-medium flex items-center gap-2 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" data-id="element-13374">
            <Calendar size={16} data-id="element-13375" />
            <span data-id="element-13376">Custom Range</span>
          </button>
        </div>
      </div>
      {/* Tabs */}
      <div className="flex border-b border-gray-200 dark:border-gray-700 mb-6" data-id="element-13377">
        <button className={`px-4 py-2 text-sm font-medium ${activeTab === 'overview' ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => setActiveTab('overview')} data-id="element-13378">
          Overview
        </button>
        <button className={`px-4 py-2 text-sm font-medium ${activeTab === 'campaigns' ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => setActiveTab('campaigns')} data-id="element-13379">
          Campaigns
        </button>
        <button className={`px-4 py-2 text-sm font-medium ${activeTab === 'performance' ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => setActiveTab('performance')} data-id="element-13380">
          Performance
        </button>
        <button className={`px-4 py-2 text-sm font-medium ${activeTab === 'analytics' ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => setActiveTab('analytics')} data-id="element-13381">
          Analytics
        </button>
      </div>
      {activeTab === 'overview' && <>
          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6" data-id="element-13382">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13383">
              <div className="flex items-center justify-between" data-id="element-13384">
                <div data-id="element-13385">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-13386">
                    Total Revenue
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mt-1" data-id="element-13387">
                    $12,426
                  </h3>
                  <p className="text-xs text-green-500 flex items-center mt-1" data-id="element-13388">
                    <TrendingUp size={12} className="mr-1" data-id="element-13389" />
                    +16.5% from last period
                  </p>
                </div>
                <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center" data-id="element-13390">
                  <DollarSign size={20} className="text-blue-600 dark:text-blue-400" data-id="element-13391" />
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13392">
              <div className="flex items-center justify-between" data-id="element-13393">
                <div data-id="element-13394">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-13395">
                    Active Campaigns
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mt-1" data-id="element-13396">
                    24
                  </h3>
                  <p className="text-xs text-green-500 flex items-center mt-1" data-id="element-13397">
                    <ArrowUp size={12} className="mr-1" data-id="element-13398" />
                    +3 from last period
                  </p>
                </div>
                <div className="w-10 h-10 rounded-full bg-purple-100 dark:bg-purple-900 flex items-center justify-center" data-id="element-13399">
                  <BarChart size={20} className="text-purple-600 dark:text-purple-400" data-id="element-13400" />
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13401">
              <div className="flex items-center justify-between" data-id="element-13402">
                <div data-id="element-13403">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-13404">
                    Conversions
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mt-1" data-id="element-13405">
                    1,843
                  </h3>
                  <p className="text-xs text-green-500 flex items-center mt-1" data-id="element-13406">
                    <TrendingUp size={12} className="mr-1" data-id="element-13407" />
                    +12.3% from last period
                  </p>
                </div>
                <div className="w-10 h-10 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center" data-id="element-13408">
                  <TrendingUp size={20} className="text-green-600 dark:text-green-400" data-id="element-13409" />
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13410">
              <div className="flex items-center justify-between" data-id="element-13411">
                <div data-id="element-13412">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-13413">
                    Total Users
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mt-1" data-id="element-13414">
                    32,695
                  </h3>
                  <p className="text-xs text-green-500 flex items-center mt-1" data-id="element-13415">
                    <TrendingUp size={12} className="mr-1" data-id="element-13416" />
                    +8.2% from last period
                  </p>
                </div>
                <div className="w-10 h-10 rounded-full bg-pink-100 dark:bg-pink-900 flex items-center justify-center" data-id="element-13417">
                  <Users size={20} className="text-pink-600 dark:text-pink-400" data-id="element-13418" />
                </div>
              </div>
            </div>
          </div>
          {/* Additional KPI Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-13419">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13420">
              <div className="flex items-center justify-between mb-2" data-id="element-13421">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-13422">
                  Conversion Rate
                </p>
                <div className="w-8 h-8 rounded-full bg-indigo-100 dark:bg-indigo-900 flex items-center justify-center" data-id="element-13423">
                  <Target size={16} className="text-indigo-600 dark:text-indigo-400" data-id="element-13424" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-13425">
                5.64%
              </h3>
              <div className="flex items-center mt-2" data-id="element-13426">
                <span className="text-xs px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-full flex items-center" data-id="element-13427">
                  <ArrowUp size={10} className="mr-1" data-id="element-13428" />
                  0.8%
                </span>
                <span className="ml-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-13429">
                  vs last period
                </span>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13430">
              <div className="flex items-center justify-between mb-2" data-id="element-13431">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-13432">
                  Average Revenue Per User
                </p>
                <div className="w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center" data-id="element-13433">
                  <DollarSign size={16} className="text-blue-600 dark:text-blue-400" data-id="element-13434" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-13435">
                $0.38
              </h3>
              <div className="flex items-center mt-2" data-id="element-13436">
                <span className="text-xs px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-full flex items-center" data-id="element-13437">
                  <ArrowUp size={10} className="mr-1" data-id="element-13438" />
                  0.05$
                </span>
                <span className="ml-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-13439">
                  vs last period
                </span>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13440">
              <div className="flex items-center justify-between mb-2" data-id="element-13441">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-13442">
                  Revenue Per Mille (RPM)
                </p>
                <div className="w-8 h-8 rounded-full bg-purple-100 dark:bg-purple-900 flex items-center justify-center" data-id="element-13443">
                  <Activity size={16} className="text-purple-600 dark:text-purple-400" data-id="element-13444" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-13445">
                $380.06
              </h3>
              <div className="flex items-center mt-2" data-id="element-13446">
                <span className="text-xs px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-full flex items-center" data-id="element-13447">
                  <ArrowUp size={10} className="mr-1" data-id="element-13448" />
                  $42.30
                </span>
                <span className="ml-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-13449">
                  vs last period
                </span>
              </div>
            </div>
          </div>
          {/* Revenue Chart */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-13450">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13451">
              <div className="flex items-center justify-between mb-4" data-id="element-13452">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13453">
                  Revenue Trend
                </h3>
                <div className="flex items-center gap-2" data-id="element-13454">
                  <button className="px-2 py-1 bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 text-xs rounded-md" data-id="element-13455">
                    Daily
                  </button>
                  <button className="px-2 py-1 text-gray-500 dark:text-gray-400 text-xs" data-id="element-13456">
                    Weekly
                  </button>
                  <button className="px-2 py-1 text-gray-500 dark:text-gray-400 text-xs" data-id="element-13457">
                    Monthly
                  </button>
                </div>
              </div>
              <div className="h-64" data-id="element-13458">
                <Chart title="Revenue Trend" data={revenueData} type="line" height={250} yAxisLabel="Revenue ($)" xAxisDataKey="date" colors={['#3b82f6']} dataKeys={['revenue']} data-id="element-13459" />
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13460">
              <div className="flex items-center justify-between mb-4" data-id="element-13461">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13462">
                  Conversions Trend
                </h3>
                <div className="flex items-center gap-2" data-id="element-13463">
                  <button className="px-2 py-1 bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 text-xs rounded-md" data-id="element-13464">
                    Daily
                  </button>
                  <button className="px-2 py-1 text-gray-500 dark:text-gray-400 text-xs" data-id="element-13465">
                    Weekly
                  </button>
                  <button className="px-2 py-1 text-gray-500 dark:text-gray-400 text-xs" data-id="element-13466">
                    Monthly
                  </button>
                </div>
              </div>
              <div className="h-64" data-id="element-13467">
                <Chart title="Conversions Trend" data={conversionData} type="bar" height={250} yAxisLabel="Conversions" xAxisDataKey="date" colors={['#10b981']} dataKeys={['conversions']} data-id="element-13468" />
              </div>
            </div>
          </div>
          {/* Segment and Device Distribution */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-13469">
            {renderRevenueBySegmentChart()}
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13470">
              <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-4" data-id="element-13471">
                Revenue by Device
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-13472">
                <div className="h-48 flex items-center justify-center" data-id="element-13473">
                  <div className="w-full h-full relative" data-id="element-13474">
                    <div className="absolute inset-0 flex items-center justify-center" data-id="element-13475">
                      <div className="text-center" data-id="element-13476">
                        <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-13477">
                          Total
                        </p>
                        <p className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-13478">
                          $12,426
                        </p>
                      </div>
                    </div>
                    {/* This would be a pie chart in a real implementation */}
                    <div className="w-full h-full flex items-center justify-center" data-id="element-13479">
                      <PieChart size={120} className="text-gray-300 dark:text-gray-700" data-id="element-13480" />
                    </div>
                  </div>
                </div>
                <div data-id="element-13481">
                  {deviceData.map(device => <div key={device.name} className="flex items-center justify-between mb-2" data-id="element-13482">
                      <div className="flex items-center" data-id="element-13483">
                        <div className="w-3 h-3 rounded-full mr-2" style={{
                    backgroundColor: device.color
                  }} data-id="element-13484"></div>
                        <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-13485">
                          {device.icon} {device.name}
                        </span>
                      </div>
                      <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-13486">
                        {device.value}%
                      </span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
          {/* Geographic Performance */}
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm mb-6" data-id="element-13487">
            <div className="flex items-center justify-between mb-4" data-id="element-13488">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13489">
                Geographic Performance
              </h3>
              <button className="text-sm text-blue-600 dark:text-blue-400 hover:underline flex items-center" data-id="element-13490">
                <Globe size={14} className="mr-1" data-id="element-13491" />
                View All Countries
              </button>
            </div>
            <div className="overflow-x-auto" data-id="element-13492">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-13493">
                <thead data-id="element-13494">
                  <tr data-id="element-13495">
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13496">
                      Country
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13497">
                      Revenue
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13498">
                      Conversions
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13499">
                      Conversion Rate
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-13500">
                      RPM
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 dark:divide-gray-700" data-id="element-13501">
                  {geoData.map((country, index) => <tr key={index} data-id="element-13502">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-13503">
                        {country.name}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-13504">
                        ${country.revenue.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-13505">
                        {country.conversions.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-13506">
                        {(country.conversions / (country.revenue / 12) * 100).toFixed(2)}
                        %
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-13507">
                        $
                        {(country.revenue / (country.conversions * 8) * 1000).toFixed(2)}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
          {/* Recent Campaigns Table */}
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-13508">
            <div className="flex items-center justify-between mb-4" data-id="element-13509">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-13510">
                Top Performing Campaigns
              </h3>
              <button className="text-sm text-blue-600 dark:text-blue-400 hover:underline flex items-center" data-id="element-13511">
                <Layers size={14} className="mr-1" data-id="element-13512" />
                View All Campaigns
              </button>
            </div>
            <div className="overflow-x-auto" data-id="element-13513">
              <table className="min-w-full" data-id="element-13514">
                <thead data-id="element-13515">
                  <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-13516">
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-13517">
                      Campaign Name
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-13518">
                      Status
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-13519">
                      Conversions
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-13520">
                      Revenue
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-13521">
                      ROI
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-13522">
                      Target Segments
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-13523">
                  {campaignsData.map((campaign, index) => <tr key={index} className="border-b border-gray-200 dark:border-gray-700" data-id="element-13524">
                      <td className="py-3 px-4 text-sm text-gray-900 dark:text-white" data-id="element-13525">
                        {campaign.name}
                      </td>
                      <td className="py-3 px-4" data-id="element-13526">
                        <span className={`px-2 py-1 text-xs rounded-full ${campaign.status === 'active' ? 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400' : campaign.status === 'scheduled' ? 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 dark:text-yellow-400' : 'bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400'}`} data-id="element-13527">
                          {campaign.status.charAt(0).toUpperCase() + campaign.status.slice(1)}
                        </span>
                      </td>
                      <td className="py-3 px-4 text-sm text-gray-900 dark:text-white" data-id="element-13528">
                        {campaign.conversions}
                      </td>
                      <td className="py-3 px-4 text-sm text-gray-900 dark:text-white" data-id="element-13529">
                        ${campaign.revenue}
                      </td>
                      <td className="py-3 px-4 text-sm text-green-500" data-id="element-13530">
                        {campaign.roi}
                      </td>
                      <td className="py-3 px-4 text-sm text-gray-700 dark:text-gray-300" data-id="element-13531">
                        <div className="flex flex-wrap gap-1" data-id="element-13532">
                          {campaign.targetSegments.map(segment => <span key={segment} className="px-2 py-0.5 bg-gray-100 dark:bg-gray-700 rounded text-xs" data-id="element-13533">
                              {segment}
                            </span>)}
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </>}
      {activeTab === 'campaigns' && renderCampaignsTab()}
      {activeTab === 'performance' && renderPerformanceTab()}
      {activeTab === 'analytics' && renderAnalyticsTab()}
    </div>;
};